export class TextProposal {
    textkuerzel_id: number;
    textkuerzel: string;
    wortgruppe: string;
}

export interface TextKuerzelApi {
    records: TextProposal[];
    count: number;
}
